"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankNodeScoped = void 0;
/**
 * A blank node that is scoped to a certain source.
 */
class BlankNodeScoped {
    termType = 'BlankNode';
    value;
    /**
     * This value can be obtained by consumers in query results,
     * so that this can be passed into another query as an IRI,
     * in order to obtain more results relating to this (blank) node.
     */
    skolemized;
    constructor(value, skolemized) {
        this.value = value;
        this.skolemized = skolemized;
    }
    equals(other) {
        // eslint-disable-next-line no-implicit-coercion
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
}
exports.BlankNodeScoped = BlankNodeScoped;
//# sourceMappingURL=BlankNodeScoped.js.map